import { Star } from "lucide-react";

const stars = [
  { t: "8%", l: "6%", s: 34, d: "0s" },
  { t: "22%", l: "18%", s: 22, d: "0.6s" },
  { t: "12%", l: "82%", s: 30, d: "1.1s" },
  { t: "34%", l: "92%", s: 20, d: "0.3s" },
  { t: "48%", l: "40%", s: 18, d: "1.5s" },
  { t: "40%", l: "62%", s: 26, d: "0.9s" },
  { t: "6%", l: "52%", s: 16, d: "1.8s" },
];

export const Stars = () =>
  stars.map((s, i) => (
    <Star
      key={i}
      className="absolute text-yellow-300 fill-yellow-300 sparkle pointer-events-none drop-shadow"
      style={{ top: s.t, left: s.l, width: s.s, height: s.s, animationDelay: s.d }}
    />
  ));

export const Clouds = () => (
  <div className="absolute bottom-0 left-0 right-0 h-40 pointer-events-none overflow-hidden" aria-hidden="true">
    <div className="cloud-drift absolute -bottom-10 -left-10 w-80 h-40 bg-white rounded-full opacity-95" />
    <div className="cloud-drift absolute -bottom-16 left-56 w-96 h-44 bg-white rounded-full opacity-90" style={{ animationDelay: "2s" }} />
    <div className="cloud-drift absolute -bottom-12 right-40 w-96 h-40 bg-white rounded-full opacity-95" style={{ animationDelay: "4s" }} />
    <div className="cloud-drift absolute -bottom-14 -right-10 w-80 h-44 bg-white rounded-full opacity-90" style={{ animationDelay: "1s" }} />
    <div className="cloud-drift absolute -bottom-20 left-[30%] w-[28rem] h-44 bg-white rounded-full" style={{ animationDelay: "3s" }} />
    <div className="cloud-drift absolute -bottom-20 right-[15%] w-[26rem] h-40 bg-white rounded-full" style={{ animationDelay: "5s" }} />
    <div className="absolute bottom-0 left-0 right-0 h-10 bg-white" />
  </div>
);
